<div class="rrhh-confirm-reactivate-member">
    <h3>
        <qr-icon name="warning" color="warning-700"></qr-icon>
        Esta por reactivar un agente dado de baja del Team. 
    </h3>
    <p>Tenga en cuenta que al activarlo <b>se perderá el historial</b> y se registrará como fecha de alta el nuevo ingreso al team. </p>
</div>